import { getWorkspaceId } from '../../lib/auth-storage';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { billingApi, type CommercialDashboard } from '../../api/billing';

const NAV = [
  { to: '/commercial/licenses', label: 'License Manager' },
  { to: '/commercial/bundles', label: 'Bundles' },
  { to: '/commercial/usage', label: 'Usage' },
  { to: '/commercial/credits', label: 'AI Credits' },
  { to: '/billing', label: 'Billing Dashboard' },
];

export function CommercialHubPage() {
  const [dashboard, setDashboard] = useState<CommercialDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void billingApi.dashboard((getWorkspaceId() ?? '')).then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Credit balance', value: dashboard.credit_balance },
        { label: 'Entitlements', value: dashboard.entitlements_active },
        { label: 'Pending invoices', value: dashboard.pending_invoices },
        { label: 'Trial days left', value: dashboard.trial_days_remaining },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Commercial Platform</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
        Licensing, subscriptions, entitlements, usage metering and AI credits.
      </p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => (
          <Link key={l.to} to={l.to} className="text-slate-700 hover:underline dark:text-slate-300">{l.label}</Link>
        ))}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
